/*
 * Get drug details
 */
import { clientFetch } from '../clientFetch';

export const getDrug = ({ params = {}, signal }) => {
  return clientFetch(`/entity/drug/${params?.drugId}`, { signal });
};
